import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ErrorPanel from 'components/Error/ErrorPanel';

const ProductGridEmpty = memo(({ breadcrumbs, pageType, reason }) => {
  const parentOffer = breadcrumbs?.[breadcrumbs.length - 1];
  const { path: parentUrl, name: parentName } = parentOffer ?? {};

  return (
    <ErrorPanel
      message
      problem={`Sorry, there are currently no products available in this ${pageType}`}
      reason={reason && `(${reason})`}
    >
      {parentName && parentUrl && (
        <Link to={parentUrl}>Take a look at other products in {parentName}</Link>
      )}
    </ErrorPanel>
  );
});

ProductGridEmpty.displayName = 'ProductGridEmpty';

ProductGridEmpty.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      urlName: PropTypes.string,
    }),
  ),
  pageType: PropTypes.string.isRequired,
  reason: PropTypes.string,
};

export default ProductGridEmpty;
